module.exports = __webpack_public_path__ + "static/media/能动-高压容弹_x264.133634b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/能动-高压容弹_x264.mp4
// module id = 3K/D
// module chunks = 13